import { createSlice } from '@reduxjs/toolkit'

export const CamapignOwnerFilterSlice = createSlice({
  name: 'campaign_owner_filter',
  initialState: {
    value: false,
  },
  reducers: {
    setCampaignOwnerFilter: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { setCampaignOwnerFilter } = CamapignOwnerFilterSlice.actions

export default CamapignOwnerFilterSlice.reducer